module.exports = __webpack_public_path__ + "static/media/logo.0ebde4c4.png";